import StakingCard from "./StakingCard";
const Staking = () => {
  return (
    <div id="Staking"
      className="container mx-auto px-4 sm:px-10 flex relative w-full"
    >
      <div className="flex w-full justify-center items-center mt-20">
        <StakingCard />
      </div>
    </div>
  )
}

export default Staking;